import { Typography } from '@mui/material'
import React from 'react'
import './footer.css'
import ResumeData from '../../utils/ResumeData'

const Footer = () => {
  return (
    <div className='footer'>
      <div className='footer_left'>
          <Typography className='footer_name'>{ResumeData.name}</Typography>
      </div>
      <div className='footer_right'>
          <Typography className='status'>Graduated in 2022</Typography>
      </div>
      </div>
  )
}

export default Footer